import _ from 'lodash';
import React, {Component} from 'react';
import PropTypes from 'prop-types';

import styles from './ConfirmDialog.scss';
import Dialog from './Dialog';
import Button from '../Button';

export default class ConfirmDialog extends Component {
    static propTypes = {
        title: PropTypes.string,
        onOk: PropTypes.func.isRequired,
        onCancel: PropTypes.func,
        onClose: PropTypes.func,
        visible: PropTypes.bool,
        buttonOkLabel: PropTypes.string,
        buttonCancelLabel: PropTypes.string,
        okButtonType: PropTypes.string,
        text: PropTypes.string,
        processing: PropTypes.bool,
    };

    static defaultProps = {
        okButtonType: 'danger',
        onCancel: _.noop,
        onClose: _.noop
    };

    render() {
        const {
            text,
            visible,
            okButtonType,
            processing
        } = this.props;

        const okLabel = this.props.buttonOkLabel || 'OK';
        const cancelLabel = this.props.buttonCancelLabel || 'Cancel';
        const title = this.props.title || 'Confirm';

        return (
            <Dialog onClose={this.handleCancel}
                    visible={visible}
                    dialogClassName={styles.confirmationDialog}
                    title={title}>

                <div className={styles.text}>
                    {text}
                </div>

                <div className={styles.buttonsPanel}>
                    <Button label={cancelLabel}
                            type='cancel'
                            className={styles.button}
                            disabled={processing}
                            onClick={this.handleCancel}/>

                    <Button label={okLabel}
                            type={okButtonType}
                            className={styles.button}
                            disabled={processing}
                            onClick={this.handleOK}/>
                </div>
            </Dialog>
        );
    }

    handleCancel = () => {
        this.props.onCancel();
        this.props.onClose();
    };

    handleOK = () => {
        this.props.onOk();
        this.props.onClose();
    };
}



// WEBPACK FOOTER //
// ./src/components/controls/dialogs/ConfirmDialog.js